// extracted by mini-css-extract-plugin
export var aspect = "pricingPlan-module--aspect--29311";
export var aspects = "pricingPlan-module--aspects--a0f56";
export var background = "pricingPlan-module--background--a026f";
export var badge = "pricingPlan-module--badge--43110";
export var container = "pricingPlan-module--container--2917f";
export var divider = "pricingPlan-module--divider--aa439";
export var essentialsTitle = "pricingPlan-module--essentials-title--1c102";
export var header = "pricingPlan-module--header--bb770";
export var name = "pricingPlan-module--name--284cc";
export var price = "pricingPlan-module--price--0243a";
export var pricePeriod = "pricingPlan-module--pricePeriod--a32d9";
export var standardTitle = "pricingPlan-module--standard-title--77cc4";
export var unlimitedTitle = "pricingPlan-module--unlimited-title--8b2b4";